import Widget from './Widget';
import WithWidgetManager from './WithWidgetManager';
import HiddenElements from './HiddenElements';
module.exports = {Widget, WithWidgetManager, HiddenElements}